import { apiGet, apiPost, apiPut, apiDelete } from './client.js';
import type { Ingredient, Ingredient as IngredientDto, Category, Unit } from './types.js';

export type IngredientInput = {
  name: string;
  category?: Category;
  default_unit?: Unit;
  default_unit_weight_g?: number | null;
  kcal_per_100: number;
  protein_per_100?: number;
  carbs_per_100?: number;
  fat_per_100?: number;
  shoppable?: boolean;
};

export type IngredientUpdate = Partial<IngredientInput>;

function qs(params: Record<string, string | number | undefined>): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === '') continue;
    sp.set(k, String(v));
  }
  const s = sp.toString();
  return s.length > 0 ? `?${s}` : '';
}

export function listIngredients(opts: { search?: string } = {}): Promise<IngredientDto[]> {
  return apiGet<IngredientDto[]>(`/api/ingredients${qs({ search: opts.search })}`);
}

export function createIngredient(body: IngredientInput): Promise<Ingredient> {
  return apiPost<Ingredient>('/api/ingredients', body);
}

export function updateIngredient(id: number, body: IngredientUpdate): Promise<Ingredient> {
  return apiPut<Ingredient>(`/api/ingredients/${id}`, body);
}

export function deleteIngredient(id: number): Promise<{ ok: true }> {
  return apiDelete<{ ok: true }>(`/api/ingredients/${id}`);
}